import { injectable, interfaces } from 'inversify';
import { IObservableArray, makeObservable, observable } from 'mobx';

export interface IApiKey {
  id: string;
  name: string;
  value: string;
  isActive: boolean;
  isActiveText: string;
}

export interface IIntegrationsStore {
  apiKeys: IObservableArray<IApiKey>;
}

export namespace IIntegrationsStore {
  export const $: interfaces.ServiceIdentifier<IIntegrationsStore> = Symbol('INTEGRATIONS_STORE');
}

@injectable()
export class IntegrationsStore implements IIntegrationsStore {
  apiKeys: IObservableArray<IApiKey> = observable.array([]);

  constructor() {
    makeObservable(this, {
      apiKeys: observable,
    });
  }
}
